import { Button } from '@chakra-ui/react'
import { LeftCarouselButtonIcon } from 'assets/icons'

export const LeftButtonIcon = ({ onClick, ...rest }) => {
  const {
    onMove,
    carouselState: { currentSlide, deviceType }
  } = rest

  return (
    <Button
      type="button"
      onClick={() => onClick()}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        position: 'absolute',
        left: '20px',
        zIndex: 1,
        fontSize: '50px',
        color: '#fff'
      }}
    >
      <LeftCarouselButtonIcon />
    </Button>
  )
}
